import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  FormControlLabel,
  Switch,
  TableHead,
  TableRow,
  TextField,
  Hidden,
  ListItem,
  Collapse,
  FormControl,
  FormLabel,
  FormGroup,
  Checkbox,
  Popover,
  Box,
  InputLabel,
  Select,
  Typography,
  Card,
  CardContent,
  CardActions,
  Divider,
  Chip,
  Tooltip,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ExpandLess from '@material-ui/icons/ExpandLess';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ExpandMore from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { Autocomplete } from '@material-ui/lab';

import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import UIButtonSearch from '../../UI/Button/Search/Search';
import useApi from '../../../utils/useApi';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import UITablePagination from '../../UI/Table/Pagination/UITablePagination';
import FormInputDate from '../../UI/Form/InputDate/FormInputDate';

import validationSchema from '../New/validationSchema';
import {
  emptyObject,
  formattedCurrency,
  isEqualObject,
} from '../../../utils/utils';

import useStyles from '../../../utils/useStyle';

const initialSearch = {
  name: '',
  description: '',
  value: '',
  bySystem: '0',
};

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const frequencies = [
  { id: 'daily', name: 'Diário' },
  { id: 'weekly', name: 'Semanal' },
  { id: 'biweekly', name: 'Quinzenal' },
  { id: 'monthly', name: 'Mensal' },
  { id: 'quarterly', name: 'Trimestral' },
  { id: 'semiannual', name: 'Semestral' },
  { id: 'annual', name: 'Anual' },
];

const CostsSearch = (children) => {
  const [alert, setAlert] = useState(false);
  const [alertUpdate, setAlertUpdate] = useState(false);
  const { disabledTextField } = useStyles();

  // salvar valores do form de pesquisa
  const [search, setSearch] = useState({});
  const [notificationCustomize, setNotificationCustomize] = useState(false);

  // modal para pagamentos
  const [modalPay, setModalPay] = useState(false);

  // paginação
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // verificar se é mobile
  const { mobile, collapseSearch, changeCollapseSearch, suppliersInfo } =
    children;

  // modais de pesquisa e filtragem
  const [view, setView] = useState(false);
  const [modalValues, setModalValues] = useState(null);
  const [filter, setFilter] = useState(false);

  // ação para click direito
  const [clickRight, setClickRight] = useState(initialClick);

  // ação para click esquerdo
  const [anchorEl, setAnchorEl] = React.useState(null);

  // recurrence popover
  const [anchorRecurrent, setAnchorRecurrent] = useState(null);
  const [anchorNotify, setAnchorNotify] = useState(null);

  const [filterLoad, filterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/costs',
    params: { bySystem: '0' },
  });

  const [costsDetailLoad] = useApi({
    method: 'get',
    url: '/costs',
  });

  const [suppliersLoad] = useApi({
    method: 'get',
    url: '/suppliers',
  });

  const [costsPutLoad, costsPutInfo, setCostsPutInfo] = useApi({
    method: 'put',
    url: '/costs',
  });

  const [costsLoad, costsInfo, setCostsInfo] = useApi({
    method: 'patch',
    url: '/costs',
  });

  useEffect(() => {
    filterLoad();
  }, [collapseSearch]);

  const humanAttributes = (costId) => {
    const supplierLoad = (id, data, metadata) =>
      suppliersLoad({
        params: { id },
        onCompleted: (response) => {
          if (response) {
            setModalValues({
              ...data,
              metadata,
              supplier: suppliersInfo.data.find(
                (value) => value.id === response.data[0].id,
              ),
              supplierName: response.data[0].name,
              notificationTitle: '',
              dueDate: new Date(),
            });
          }
        },
      });

    costsDetailLoad({
      params: { id: costId },
      onCompleted: (res) => {
        if (res) {
          const data = res.data[0];
          const { metadata } = data;
          supplierLoad(metadata.supplier, data, metadata);
        }
      },
    });
  };

  const handleClickRight = (event, costId) => {
    event.preventDefault();
    if (costId) {
      humanAttributes(costId);
    }
    setClickRight({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  const handleCloseClickRight = () => {
    setClickRight(initialClick);
  };

  const handleClickLeft = (event, costId) => {
    if (costId) {
      humanAttributes(costId);
    }
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => {
    setAnchorEl(null);
  };

  function changeValuesPayment(value, attribute) {
    if (Number(value) <= 0) {
      setModalValues({ ...modalValues, errors: 'Pagamento invalido' });
      return;
    }
    setModalValues({ ...modalValues, [attribute]: value, errors: false });
  }

  function handleModalFilter() {
    setFilter(!filter);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function handleModalPay(costId, isClick) {
    if (costId) {
      humanAttributes(costId);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setModalPay(!modalPay);
    setNotificationCustomize(false);
  }

  function handleModalView(costId, isClick) {
    if (costId) {
      humanAttributes(costId);
    }
    if (isClick) {
      const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
      closeMenu();
    }
    setView(!view);
  }

  function onSearch(values) {
    const searchValues = { ...values, bySystem: values.bySystem };
    filterLoad({
      debounced: true,
      params: emptyObject(searchValues),
    });
    setSearch(emptyObject(searchValues));
  }

  function onPay() {
    const data = {
      costId: modalValues.id,
      supplier: modalValues.supplier.id,
      value: modalValues.value,
      notificationTitle: modalValues.notificationTitle,
      dueDate: modalValues.dueDate,
    };
    costsLoad({
      data,
      onCompleted: () => {
        setAlert(!alert);
        onSearch(search);
        handleModalPay();
      },
    });
  }

  function onUpdate(values) {
    const data = {
      id: values.id,
      name: values.name,
      description: values.description,
      value: values.value,
      metadata: values.metadata,
    };
    data.metadata.type = 'SINGLE';
    costsPutLoad({
      data,
      onCompleted: () => {
        setAlertUpdate(!alertUpdate);
        onSearch(search);
        handleModalView();
      },
    });
  }

  const handleOpenRecurrent = (event) => {
    setAnchorRecurrent(event.currentTarget);
  };

  const handleCloseRecurrent = () => {
    setAnchorRecurrent(null);
  };

  const handleOpenNotify = (event) => {
    setAnchorNotify(event.currentTarget);
  };

  const handleCloseNotify = () => {
    setAnchorNotify(null);
  };

  return (
    <>
      <UIContainer container direction="row">
        <ListItem
          button
          onClick={changeCollapseSearch}
          style={{ justifyContent: 'space-between' }}
        >
          <UIFormTitle title="Filtrar custos" />
          {collapseSearch ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={collapseSearch}
          timeout="auto"
          unmountOnExit
          style={{ width: '100%' }}
        >
          <>
            <Formik onSubmit={onSearch} initialValues={initialSearch}>
              {({ values, submitForm, setFieldValue }) => (
                <Form style={{ width: '100%' }} onChange={() => submitForm()}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item xs={2} md={1}>
                      <Field
                        name="id"
                        label="ID"
                        placeholder="ID"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={8} md={2}>
                      <Field
                        name="name"
                        label="Nome"
                        placeholder="Nome do custo"
                        fullWidth
                        as={TextField}
                        id="tour-costs-search-name"
                      />
                    </Grid>
                    <Hidden smDown>
                      <Grid item xs={12} md={3}>
                        <Field
                          name="description"
                          label="Descrição"
                          placeholder="Descrição do custo"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <CurrencyTextField
                          type="tel"
                          value={values.value}
                          label="Valor do custo"
                          decimalCharacter=","
                          digitGroupSeparator="."
                          currencySymbol="R$"
                          outputFormat="string"
                          fullWidth
                          onChange={(ev, value) =>
                            setFieldValue('value', value)
                          }
                        />
                      </Grid>
                      <Grid item xs={2} md={2}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Custos</FormLabel>
                          <FormControlLabel
                            label={
                              values.bySystem === '1'
                                ? 'Automaticos'
                                : 'Manuais'
                            }
                            labelPlacement="start"
                            control={
                              <Switch
                                color="default"
                                id="tour-costs-search-bysystem"
                                checked={values.bySystem === '1'}
                                onChange={(ev) =>
                                  setFieldValue(
                                    'bySystem',
                                    ev.target.checked ? '1' : '0',
                                  )
                                }
                              />
                            }
                          />
                        </FormControl>
                      </Grid>
                    </Hidden>
                    <Hidden mdUp>
                      <UIFilter onClick={handleModalFilter} />
                    </Hidden>
                    <Hidden smDown>
                      <UIButtonSearch xs={1} />
                    </Hidden>
                  </Grid>

                  <UIModalFilter
                    open={filter}
                    changeModal={handleModalFilter}
                    submit={submitForm}
                  >
                    <Grid item xs={12} md={3}>
                      <Field
                        name="description"
                        label="Descrição"
                        placeholder="Descrição do custo"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <CurrencyTextField
                        type="tel"
                        value={values.value}
                        label="Valor do custo"
                        decimalCharacter=","
                        digitGroupSeparator="."
                        currencySymbol="R$"
                        outputFormat="string"
                        fullWidth
                        onChange={(ev, value) => setFieldValue('value', value)}
                      />
                    </Grid>
                    <Grid item xs={2} md={2}>
                      <FormControl component="fieldset">
                        <FormLabel component="legend">Custos</FormLabel>
                        <FormControlLabel
                          label={values.isActive ? 'Alt' : 'Inativas'}
                          labelPlacement="start"
                          control={
                            <Switch
                              color="default"
                              checked={values.isActive}
                              onChange={(ev) =>
                                setFieldValue('isActive', ev.target.checked)
                              }
                            />
                          }
                        />
                      </FormControl>
                    </Grid>
                  </UIModalFilter>
                </Form>
              )}
            </Formik>

            <Grid item xs style={{ marginTop: '15px' }}>
              {/* Tabela Desktop */}
              <Hidden smDown>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Nome</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell>Valor</TableCell>
                        <TableCell>Ações</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filterInfo.loading && <CircularProgress />}
                      {filterInfo.data &&
                        filterInfo.data
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage,
                          )
                          .map((data) => (
                            <TableRow
                              onDoubleClick={() => handleModalView(data.id)}
                              onContextMenu={
                                !mobile
                                  ? (ev) => handleClickRight(ev, data.id)
                                  : undefined
                              }
                              style={{ cursor: 'context-menu' }}
                              hover
                              key={data.id}
                            >
                              <TableCell
                                onClick={
                                  mobile
                                    ? (ev) => handleClickLeft(ev, data.id)
                                    : undefined
                                }
                                component="th"
                                scope="row"
                              >
                                {data.id}
                              </TableCell>
                              <TableCell
                                onClick={
                                  mobile
                                    ? (ev) => handleClickLeft(ev, data.id)
                                    : undefined
                                }
                              >
                                {data.name}
                              </TableCell>
                              <TableCell
                                onClick={
                                  mobile
                                    ? (ev) => handleClickLeft(ev, data.id)
                                    : undefined
                                }
                              >
                                {data.description}
                              </TableCell>
                              <TableCell
                                onClick={
                                  mobile
                                    ? (ev) => handleClickLeft(ev, data.id)
                                    : undefined
                                }
                              >
                                {formattedCurrency(data.value)}
                              </TableCell>
                              <TableCell>
                                <Tooltip title="Solicitar pagamento">
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => handleModalPay(data.id)}
                                  >
                                    <MonetizationOnIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Visualizar/Editar">
                                  <IconButton
                                    size="small"
                                    onClick={() => handleModalView(data.id)}
                                  >
                                    <SearchIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                      <Menu
                        keepMounted
                        open={clickRight.mouseY !== null}
                        onClose={handleCloseClickRight}
                        anchorReference="anchorPosition"
                        anchorPosition={
                          clickRight.mouseY !== null && clickRight.mouseX !== null
                            ? {
                              top: clickRight.mouseY,
                              left: clickRight.mouseX,
                            }
                            : undefined
                        }
                      >
                        <MenuItem onClick={() => handleModalView(null, true)}>
                          Visualizar/Editar
                        </MenuItem>
                        <MenuItem onClick={() => handleModalPay(null, true)}>
                          Solicitar pagamento
                        </MenuItem>
                      </Menu>
                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={() => handleCloseClickLeft()}
                      >
                        <MenuItem onClick={() => handleModalView(null, true)}>
                          Visualizar/Editar
                        </MenuItem>
                        <MenuItem onClick={undefined}>
                          Solicitar pagamento
                        </MenuItem>
                      </Menu>
                      {filterInfo.error && (
                        <TableRow>
                          <TableCell colSpan={5}>Sem resultados encontrados</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <UITablePagination
                    count={filterInfo.data ? filterInfo.data.length : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </Hidden>

              {/* Listagem em Cards Mobile */}
              <Hidden mdUp>
                <Box style={{ width: '100%' }}>
                  {filterInfo.loading && (
                    <CircularProgress style={{ margin: '16px auto', display: 'block' }} />
                  )}
                  {filterInfo.data &&
                    filterInfo.data
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((data) => (
                        <Card
                          key={data.id}
                          variant="outlined"
                          style={{
                            marginBottom: 12,
                            borderLeft: '4px solid #17497F',
                            borderRadius: 8,
                          }}
                        >
                          <CardContent style={{ paddingBottom: 8 }}>
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              mb={1}
                            >
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold' }}
                              >
                                #{data.id} - {data.name}
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                style={{ fontWeight: 'bold', color: '#17497F' }}
                              >
                                {formattedCurrency(data.value)}
                              </Typography>
                            </Box>
                            {data.description && (
                              <>
                                <Divider style={{ margin: '8px 0' }} />
                                <Typography variant="body2" color="textSecondary">
                                  {data.description}
                                </Typography>
                              </>
                            )}
                          </CardContent>
                          <CardActions
                            style={{
                              justifyContent: 'flex-end',
                              paddingTop: 0,
                              paddingRight: 16,
                              paddingBottom: 8,
                            }}
                          >
                            <Tooltip title="Solicitar pagamento">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleModalPay(data.id)}
                              >
                                <MonetizationOnIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Visualizar/Editar">
                              <IconButton
                                size="small"
                                onClick={() => handleModalView(data.id)}
                              >
                                <SearchIcon />
                              </IconButton>
                            </Tooltip>
                          </CardActions>
                        </Card>
                      ))}
                  {filterInfo.error && (
                    <Typography color="textSecondary" align="center" style={{ padding: '16px 0' }}>
                      Sem resultados encontrados
                    </Typography>
                  )}
                  <UITablePagination
                    count={filterInfo.data ? filterInfo.data.length : 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Box>
              </Hidden>
            </Grid>
          </>
        </Collapse>
      </UIContainer>

      {modalValues && (
        <>
          <Dialog
            open={view}
            onClose={() => handleModalView()}
            onExit={() => setModalValues(null)}
          >
            <Formik
              enableReinitialize
              onSubmit={onUpdate}
              initialValues={{
                ...modalValues,
                metadata: {
                  ...modalValues.metadata,
                },
              }}
              validationSchema={validationSchema}
            >
              {({ values, errors, submitForm, setFieldValue }) => (
                <Form>
                  <UIDialogTitle
                    id="form-dialog-title"
                    onClose={() => handleModalView()}
                  >
                    {modalValues.name}
                  </UIDialogTitle>
                  <DialogContent>
                    <Grid container direction="row" spacing={1}>
                      <Grid item xs={12}>
                        <Field
                          name="name"
                          error={Boolean(errors.name)}
                          helperText={errors.name}
                          label="Nome do custo"
                          placeholder="Informe o nome do custo"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          name="description"
                          error={Boolean(errors.description)}
                          helperText={errors.description}
                          label="Descrição do custo"
                          placeholder="Informe a descrição do custo"
                          fullWidth
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          name="supplier"
                          className={disabledTextField}
                          disabled
                          value={modalValues.supplierName}
                          label="Fornecedor"
                          placeholder="Informe o fornecedor do custo"
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CurrencyTextField
                          type="tel"
                          value={modalValues.value}
                          error={Boolean(errors.value)}
                          helperText={errors.value}
                          label="Valor do custo"
                          decimalCharacter=","
                          digitGroupSeparator="."
                          currencySymbol="R$"
                          onChange={(ev, value) =>
                            setFieldValue('value', value)
                          }
                          outputFormat="string"
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CurrencyTextField
                          type="tel"
                          value={modalValues.totalPaid}
                          label="Total pago"
                          decimalCharacter=","
                          digitGroupSeparator="."
                          currencySymbol="R$"
                          outputFormat="string"
                          className={disabledTextField}
                          disabled
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Box display="flex" alignItems="center">
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              Recorrência
                            </FormLabel>
                            <FormControlLabel
                              label={
                                values.metadata.recurrent.activate
                                  ? 'Ativado'
                                  : 'Desativado'
                              }
                              labelPlacement="start"
                              control={
                                <Switch
                                  color="primary"
                                  checked={values.metadata.recurrent.activate}
                                  onChange={(ev) => {
                                    setFieldValue(
                                      'metadata.recurrent.activate',
                                      ev.target.checked,
                                    );
                                    if (ev.target.checked) {
                                      handleOpenRecurrent(ev);
                                    }
                                  }}
                                />
                              }
                            />
                          </FormControl>
                          {values.metadata.recurrent.activate && (
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={handleOpenRecurrent}
                            >
                              <SettingsIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                        <Popover
                          open={Boolean(anchorRecurrent)}
                          anchorEl={anchorRecurrent}
                          onClose={handleCloseRecurrent}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                          }}
                        >
                          <Box p={3} width={300}>
                            <Typography variant="h6" gutterBottom>
                              Configurar Recorrência
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <FormControl fullWidth>
                                  <InputLabel shrink id="recurrent-frequency">
                                    Frequência
                                  </InputLabel>
                                  <Select
                                    value={values.metadata.recurrent.frequency}
                                    onChange={(ev) =>
                                      setFieldValue(
                                        'metadata.recurrent.frequency',
                                        ev.target.value,
                                      )
                                    }
                                    labelId="recurrent-frequency"
                                    displayEmpty
                                  >
                                    {frequencies.map(({ id, name }) => (
                                      <MenuItem key={id} value={id}>
                                        {name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              {['monthly', 'quarterly', 'semiannual', 'annual'].includes(
                                values.metadata.recurrent.frequency,
                              ) && (
                                  <Grid item xs={12}>
                                    <Field
                                      name="metadata.recurrent.dueDay"
                                      label="Vencimento (dia)"
                                      type="number"
                                      fullWidth
                                      as={TextField}
                                    />
                                  </Grid>
                                )}
                              {['weekly', 'monthly', 'quarterly', 'semiannual', 'annual'].includes(
                                values.metadata.recurrent.frequency,
                              ) && (
                                  <Grid item xs={12}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="space-between"
                                    >
                                      <FormControl component="fieldset">
                                        <FormLabel component="legend">
                                          Notificar antecipadamente
                                        </FormLabel>
                                        <FormControlLabel
                                          label={
                                            values.metadata.recurrent.notifyDaysBefore > 0
                                              ? 'Ativado'
                                              : 'Desativado'
                                          }
                                          labelPlacement="start"
                                          control={
                                            <Switch
                                              color="primary"
                                              checked={values.metadata.recurrent.notifyDaysBefore > 0}
                                              onChange={(ev) => {
                                                const isChecked = ev.target.checked;
                                                setFieldValue(
                                                  'metadata.recurrent.notifyDaysBefore',
                                                  isChecked ? 1 : 0,
                                                );
                                                if (isChecked) {
                                                  handleOpenNotify(ev);
                                                }
                                              }}
                                            />
                                          }
                                        />
                                      </FormControl>
                                      {values.metadata.recurrent.notifyDaysBefore > 0 && (
                                        <IconButton
                                          size="small"
                                          color="primary"
                                          onClick={handleOpenNotify}
                                        >
                                          <SettingsIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                    </Box>
                                    <Popover
                                      open={Boolean(anchorNotify)}
                                      anchorEl={anchorNotify}
                                      onClose={handleCloseNotify}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                      }}
                                    >
                                      <Box p={3} width={250}>
                                        <Typography variant="h6" gutterBottom>
                                          Antecipação
                                        </Typography>
                                        <Grid container spacing={2}>
                                          <Grid item xs={12}>
                                            <Field
                                              name="metadata.recurrent.notifyDaysBefore"
                                              label="Dias de antecedência"
                                              type="number"
                                              fullWidth
                                              as={TextField}
                                              helperText="Quantos dias antes do vencimento gerar a conta?"
                                            />
                                          </Grid>
                                          <Grid item xs={12}>
                                            <Button
                                              fullWidth
                                              variant="contained"
                                              color="primary"
                                              onClick={handleCloseNotify}
                                            >
                                              Confirmar
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </Box>
                                    </Popover>
                                  </Grid>
                                )}
                              <Grid item xs={12}>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  color="primary"
                                  onClick={handleCloseRecurrent}
                                >
                                  Confirmar
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        </Popover>
                      </Grid>
                    </Grid>
                  </DialogContent>
                  <DialogActions>
                    {!isEqualObject(values, modalValues) && (
                      <Button onClick={() => handleModalView()} color="primary">
                        Cancelar
                      </Button>
                    )}
                    <Button
                      onClick={
                        isEqualObject(values, modalValues)
                          ? () => handleModalView()
                          : () => submitForm()
                      }
                      color="primary"
                    >
                      {isEqualObject(values, modalValues) ? 'Fechar' : 'Salvar'}
                    </Button>
                  </DialogActions>
                </Form>
              )}
            </Formik>
          </Dialog>

          <Dialog
            open={modalPay}
            onClose={() => handleModalPay(false)}
            onExit={() => setModalValues(null)}
          >
            <UIDialogTitle id="alert-dialog-title">
              Solicitar pagamento {modalValues.name}
            </UIDialogTitle>
            <DialogContent>
              <Grid container direction="row" spacing={1}>
                <Grid item xs={12}>
                  <Autocomplete
                    disableClearable
                    value={modalValues.supplier}
                    noOptionsText="Sem opções"
                    disabled={suppliersInfo.loading}
                    options={
                      suppliersInfo.data !== null ? suppliersInfo.data : []
                    }
                    getOptionLabel={(supplier) => supplier.name}
                    onChange={(ev, supplier) =>
                      changeValuesPayment(supplier, 'supplier')
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Fornecedor"
                        name="supplier"
                        variant="standard"
                        placeholder="Informe o fornecedor do custo"
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CurrencyTextField
                    type="tel"
                    value={modalValues.value}
                    error={Boolean(modalValues.errors)}
                    helperText={modalValues.errors}
                    label="Valor"
                    variant="standard"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    currencySymbol="R$"
                    outputFormat="string"
                    onChange={(ev, value) =>
                      changeValuesPayment(value, 'value')
                    }
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormInputDate
                    value={modalValues.dueDate}
                    label="Data de vencimento"
                    placeholder="Informe a data vencimento do custo"
                    onChange={(value) => changeValuesPayment(value, 'dueDate')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset">
                    <FormGroup row>
                      <FormControlLabel
                        style={{ margin: 0 }}
                        label="Personalizar notificação"
                        labelPlacement="start"
                        control={
                          <Checkbox
                            checked={notificationCustomize}
                            onChange={(ev, checked) =>
                              setNotificationCustomize(checked)
                            }
                          />
                        }
                      />
                    </FormGroup>
                  </FormControl>
                </Grid>
                {notificationCustomize && (
                  <Grid item xs={12}>
                    <TextField
                      value={modalValues.notificationTitle}
                      label="Nome notificação"
                      name="notificationTitle"
                      placeholder="Informe o nome da notificação"
                      onChange={(ev) =>
                        changeValuesPayment(
                          ev.target.value,
                          'notificationTitle',
                        )
                      }
                      fullWidth
                    />
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid item>
                <Button onClick={() => handleModalPay()} color="primary">
                  Não
                </Button>
                <Button onClick={onPay} color="primary" autoFocus>
                  Sim
                </Button>
              </Grid>
            </DialogActions>
          </Dialog>
        </>
      )
      }

      <UIDialogConfirm
        open={alert}
        close={() => setAlert(false)}
        data={costsInfo}
        setrequestinfo={setCostsInfo}
        messageSucess={costsInfo.data && costsInfo.data.message}
      />
      <UIDialogConfirm
        open={alertUpdate}
        close={() => setAlertUpdate(false)}
        data={costsPutInfo}
        setrequestinfo={setCostsPutInfo}
        messageSucess={costsPutInfo.data && costsPutInfo.data.message}
      />
    </>
  );
};

export default CostsSearch;
